import { useEffect, useState } from "react";
import axios from "axios";
import { API, fmtDate } from "@/lib/api";

export default function WhatsNew() {
  const [d, setD] = useState(null);
  useEffect(() => {
    axios.get(`${API}/public/whats-new`).then((r) => setD(r.data));
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F0]">
      <header className="max-w-4xl mx-auto px-6 pt-16 pb-10 rise">
        <div className="font-mono-meta text-[11px] tracking-[0.3em] text-[#5E2B38]">{(d?.brand_name || "Soft Spine Press").toUpperCase()}</div>
        <h1 className="font-playfair text-5xl sm:text-6xl mt-4">What's new</h1>
        <p className="font-body-serif italic text-[#5C5255] mt-3">Every guide is checked for accuracy every six months. Here's what changed, edition by edition.</p>
      </header>
      <main className="max-w-4xl mx-auto px-6 pb-20 space-y-8" data-testid="whats-new-list">
        {d?.titles?.map((t) => (
          <article key={t.id} id={t.id} className="bg-[#FFFDF9] border border-[#2A2325]/10 grid sm:grid-cols-12" data-testid={`whats-new-${t.id}`}>
            <div className="sm:col-span-4 p-6" style={{ background: t.theme.dark }}>
              <div className="font-mono-meta text-[10px] tracking-[0.24em] uppercase" style={{ color: t.theme.accent }}>{t.series || t.category}{t.issue_no ? ` · No. ${t.issue_no}` : ""}</div>
              <h2 className="font-playfair text-3xl text-[#F3EBD6] mt-3 leading-tight">{t.title}</h2>
              <div className="text-xs text-[#F3EBD6]/70 mt-4">Edition {t.edition} · updated {fmtDate(t.last_updated)}</div>
              <div className="text-xs text-[#F3EBD6]/70">Next review {fmtDate(t.next_update_due)}</div>
            </div>
            <div className="sm:col-span-8 p-6 space-y-4">
              {t.history.map((h) => (
                <div key={h.edition} className="border-l-2 pl-4" style={{ borderColor: t.theme.accent }}>
                  <div className="font-playfair text-lg">Edition {h.edition} <span className="text-xs text-[#5C5255] font-sans">{fmtDate(h.date)}</span></div>
                  <ul className="text-sm text-[#5C5255] mt-1 space-y-0.5">{(h.notes || []).map((n, i) => <li key={i}>— {n}</li>)}</ul>
                </div>
              ))}
            </div>
          </article>
        ))}
        {d && !d.titles.length && <p className="font-body-serif italic text-[#5C5255]" data-testid="whats-new-empty">New titles are on their way.</p>}
        <footer className="text-xs text-[#5C5255] pt-6">{d?.website || "softspinepress.com"}</footer>
      </main>
    </div>
  );
}
